import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAudibleComponent } from './simple-icons-audible.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAudibleComponent ],
    exports:      [ SimpleIconsAudibleComponent ],
    bootstrap:    []
})
export class SimpleIconsAudibleModule {}
